/**
 * SRO Gallery Overlays — pagination counter wiring
 * ----------------------------------------------------------------------------
 * Listens for Swiper slide changes inside Hyper's <media-gallery> and
 * updates the overlay's "01 / 04" pagination counter to reflect the
 * active slide.
 *
 * Why a bespoke script instead of Swiper's built-in fraction pagination:
 *   Hyper already uses .swiper-pagination with type:"bullets" for mobile
 *   (see product-media-gallery.liquid line 98). Hijacking that element
 *   would fight the theme in both directions. Cleaner to read realIndex
 *   off the swiper instance and paint our own counter node.
 *
 * Robustness:
 *   - Retries binding up to 3 seconds in case swiper isn't initialized
 *     yet when this script runs (common when gallery JS defers).
 *   - Reacts to shopify:section:load so quick-view and section re-renders
 *     pick up the counter too.
 *   - No-ops silently if the overlay element isn't present (e.g. a
 *     product with only one image — pagination markup is omitted).
 *
 * Tiny: no deps, no framework. Vanilla ES that Hyper's build won't
 * minify (dropped in /assets so Shopify serves it as-is via {{ asset_url }}).
 *
 * Author:  RevShift Media · hello@revshiftmedia.com
 * Project: Stay Ready Outdoors (c5e15f-6e.myshopify.com)
 * Created: 2026-04-17
 */
(function () {
  'use strict';

  function pad2(n) {
    var num = parseInt(n, 10) || 0;
    return num < 10 ? '0' + num : String(num);
  }

  function bindCounter(gallery) {
    if (!gallery || gallery.__sroOverlayBound) return;
    var pagEl = gallery.querySelector('[data-sro-gallery-pagination]');
    if (!pagEl) return;

    var currentEl = pagEl.querySelector('[data-sro-gallery-current]');
    var totalEl = pagEl.querySelector('[data-sro-gallery-total]');
    if (!currentEl) return;

    // The Swiper instance lives on the viewer element (Hyper attaches
    // .swiper to it). Might take a tick to initialize.
    var viewer = gallery.querySelector('.product__media-gallery-viewer');
    if (!viewer) return;

    var attempts = 0;
    var maxAttempts = 30; // ~3s at 100ms intervals

    function update() {
      var swiper = viewer.swiper;
      if (!swiper) return;
      var idx = (typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex) || 0;
      currentEl.textContent = pad2(idx + 1);
      if (totalEl && swiper.slides && swiper.slides.length) {
        totalEl.textContent = pad2(swiper.slides.length);
      }
    }

    function tryBind() {
      var swiper = viewer.swiper;
      if (swiper) {
        update();
        swiper.on('slideChange', update);
        swiper.on('slideChangeTransitionEnd', update);
        gallery.__sroOverlayBound = true;
        return;
      }
      if (++attempts < maxAttempts) {
        setTimeout(tryBind, 100);
      }
    }

    tryBind();
  }

  function scan(root) {
    var scope = root || document;
    var galleries = scope.querySelectorAll ? scope.querySelectorAll('media-gallery') : [];
    galleries.forEach(bindCounter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  // Section re-renders (theme editor + quick-view)
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();
